var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},_vm._l((_vm.socials),function(social,i){return _c('FooterIcon',{key:i,attrs:{"social":social}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }